import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isPartner", "onTabClick"];
import { ACRouterTab } from 'academy-common-lib/components/ACRouterTab';
import RouterTabs from 'ui-addon-react-router-dom/RouterTabs';
import { useTabsConfig } from './ACPage/hooks/useTabsConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const ACNavTabs = _ref => {
  let {
      isPartner,
      onTabClick
    } = _ref,
    routerTabsProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const tabsConfig = useTabsConfig({
    isPartner
  });
  return /*#__PURE__*/_jsx(RouterTabs, Object.assign({
    bordered: false
  }, routerTabsProps, {
    children: tabsConfig.map(tab => /*#__PURE__*/_jsx(ACRouterTab, {
      exact: tab.exact,
      onClick: () => onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(tab.tabId),
      tabId: tab.tabId,
      title: tab.title,
      to: tab.to
    }, tab.tabId))
  }));
};